// Copyright (c) 2019-present Ithpower, Inc. All Rights Reserved.
// See LICENSE.txt for license information.
import React from 'react';
import {Location, History} from 'history';

import {loginByAutoToken} from 'server/actions/users';
import {loadEnterpriseAdmins} from 'server/actions/staffs';
import {IsvType, IsvTypeAppName} from 'types/users';
import GlobalContext from 'context/global_context';

import {setClientSingalByCookies} from 'utils/utils';
import {setDingtalkTitle} from 'utils/dingtalk_utils';

import TripartiteAuthBase, {AuthBaseProps} from 'pages/sso/tripartite_auth_base';

class AutoLogin extends TripartiteAuthBase {
    token: string | null | undefined;
    platformType: string | null | undefined;

    constructor(props: AuthBaseProps) {
        super(props);

        const search = new URLSearchParams(props.location.search);
        this.token = search.get('token');
        this.isvAppType = search.get('isvAppType') as IsvType;
        this.platformType = search.get('platformType');
    }

    componentDidMount() {
        if (!this.token) {
            this.handleAuthInvalid();
            return;
        }

        const title = this.isvAppType === 'Performance' ? '智办事绩效-登录' : '互成协作-登录';
        setDingtalkTitle(title);

        this.autoLogin();
    }

    reTry = () => {
        this.handleStatusInit();
        this.autoLogin();
    };

    autoLogin = () => {
        if (this.token) {
            loginByAutoToken({
                token: this.token,
                isv_app_type: this.isvAppType,
                platform_type: this.platformType,
            }).then(({error}) => {
                if (error) {
                    if (error.server_error_id === 'no_ding_talk_auth') {
                        const appName = this.isvAppType ? IsvTypeAppName[this.isvAppType] : '未知';
                        this.settingErrorMessage(`你还没有开通应用的使用权限，请联系企业管理员在“工作台-全员-${appName}-可见范围”帮你开通。`);
                    }
                    this.handleAuthError();
                    return;
                }
                this.finishSignin();
            });
        }
    };

    finishSignin = () => {
        setClientSingalByCookies();
        this.verifyEnterpriseInfo();
    };

    verifyEnterpriseInfo = () => {
        loadEnterpriseAdmins().then(({error, data}) => {
            if (error) {
                setTimeout(this.verifyEnterpriseInfo, 5000);
            } else if (data && data.length !== 0) {
                this.redirectToHomePage();
            } else {
                this.props.history?.replace('/admin_setting');
            }
        });
    };
}

class WrapperContext extends React.PureComponent<{location: Location, history: History}> {
    render() {
        return (
            <GlobalContext.Consumer>
                {({clientConfig}) =>
                    (<AutoLogin
                        location={this.props.location}
                        history={this.props.history}
                        clientConfig={clientConfig}
                    />)
                }
            </GlobalContext.Consumer>
        );
    }
}

export default WrapperContext;
